export const RESET_PASS_OPTIONS = {
  width: '600px',
  maxWidth: '95vw',
  panelClass: 'no-radius-dialog',
};
